export interface DocBuilderFederationContext {
  section?: string;
  submodule?: string;
}

declare global {
  interface Window {
    __DOC_BUILDER_CONTEXT__?: DocBuilderFederationContext;
  }
}

export function setDocBuilderContext(patch: DocBuilderFederationContext): void {
  if (typeof window === 'undefined') return;
  window.__DOC_BUILDER_CONTEXT__ = { ...window.__DOC_BUILDER_CONTEXT__, ...patch };
}

export function getDocBuilderContext(): DocBuilderFederationContext | undefined {
  if (typeof window === 'undefined') return undefined;
  return window.__DOC_BUILDER_CONTEXT__;
}

export function clearDocBuilderContext(): void {
  if (typeof window === 'undefined') return;
  delete window.__DOC_BUILDER_CONTEXT__;
}
